<div class="wrapper">
    <div class="spinner pie animation-duration" [ngClass]="[ isTimerStarted === false ? 'paused': '']"
        [id]="id + 'spinner'"></div>
    <div class="filler pie animation-duration" [ngClass]="[ isTimerStarted === false ? 'paused': '']"
        [id]="id + 'filler'"></div>
    <div class="mask animation-duration" [ngClass]="[isTimerStarted === false ? 'paused': '']" [id]="id + 'mask'">
    </div>
    <div class="timer-text">{{timerString}}</div>
</div>